const companies = [
  '株式会社ノースゲート', '青空ソリューションズ株式会社', '株式会社グロースリンク',
  '東都ビジネスパートナーズ', '株式会社ミライワークス', 'サンライズ経営支援',
  '株式会社アークフィールド', '日本ビジネスデザイン株式会社', '株式会社オフィスラボ',
  'ネクストステージ合同会社'
];
const surnames = ['佐藤', '鈴木', '高橋', '田中', '伊藤', '渡辺', '山本', '中村', '小林', '加藤'];
const ranks = ['A', 'B', 'C'];
const now = Date.now();

export const makeDemoContacts = () => Array.from({ length: 30 }, (_, i) => ({
  id: `demo-${i + 1}`,
  isDemo: true,
  name: `${surnames[i % 10]} ${['健太', '美咲', '大輔'][i % 3]}`,
  company: companies[i % companies.length],
  title: ['代表取締役', '営業部長', '事業開発担当'][i % 3],
  email: `demo${i + 1}@example.jp`,
  phone: `03-5555-${String(1000 + i).slice(1)}`,
  customers: [0, 8, 25, 60, 120][i % 5],
  opportunities: [1, 4, 12, 18, 30][i % 5],
  intent: ['具体的に提案したい', '情報収集したい', '提案を検討中'][i % 3],
  purpose: ['代理店制度を知りたい', '顧客への提案商材を探している', 'CRM市場を学びたい'][i % 3],
  score: [88, 72, 48, 91, 57, 34][i % 6],
  rank: ranks[[0, 1, 2, 3, 4, 5][i % 6] < 2 ? 0 : [0, 1, 2, 3, 4, 5][i % 6] < 4 ? 1 : 2],
  attendance: ['参加', '欠席', '参加', '未確認'][i % 4],
  materials: i % 3 !== 0,
  emailStatus: i % 5 === 0 ? '停止' : '配信可能',
  partner: i % 9 === 0 ? '登録済み' : '未登録',
  meeting: i % 7 === 0 ? '予約済み' : '未予約',
  opportunity: i % 11 === 0 ? '案件化' : '未作成',
  lastTouch: new Date(now - (i + 1) * 86400000).toISOString(),
  nextAction: ['商談案内を送付', '成功事例を案内', '次回ウェビナーを案内'][i % 3],
  history: [{ at: new Date(now - (i + 1) * 86400000).toISOString(), text: 'ウェビナーに申し込み（デモデータ）' }]
}));

export const defaultWebinars = [{
  id: 'webinar-1',
  name: 'CRM提案で広げる代理店ビジネス入門',
  description: '法人顧客への提案機会を増やすCRM/SFA活用と、代理店制度をご紹介します。',
  date: new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 16),
  speaker: '事業開発チーム',
  url: 'https://example.com/webinar-room',
  bonus: '代理店向け提案ガイド',
  status: '受付中',
  capacity: 100
}];

export const defaultWorkflows = [
  { id: 'registration', title: '申込受付完了', trigger: 'フォーム送信', timing: '即時', condition: '全申込者', enabled: true, subject: 'ウェビナーのお申し込みを受け付けました' },
  { id: 'three-days', title: '開催3日前のご案内', trigger: '開催日時', timing: '3日前', condition: '申込者', enabled: true, subject: '開催3日前：CRM提案の市場機会をご紹介' },
  { id: 'one-day', title: '前日リマインド', trigger: '開催日時', timing: '前日', condition: '申込者', enabled: true, subject: '明日のウェビナーと参加特典のご案内' },
  { id: 'one-hour', title: '1時間前リマインド', trigger: '開催日時', timing: '1時間前', condition: '申込者', enabled: true, subject: 'まもなく開催：参加URLのご案内' },
  { id: 'follow-up', title: '参加後のお礼', trigger: '参加情報の取得', timing: '参加後すぐ', condition: '参加者', enabled: true, subject: 'ご参加ありがとうございました' },
  { id: 'absent', title: '欠席者への資料案内', trigger: '参加情報の取得', timing: '終了後', condition: '欠席者', enabled: true, subject: '当日の概要資料をお送りします' },
  { id: 'nurture', title: '長期育成メール', trigger: 'スコア判定', timing: '毎月', condition: '配信同意済みのCランク', enabled: false, subject: '代理店ビジネスの最新情報' }
];

export const sampleEvent = (type, detail) => ({
  id: `event-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
  type,
  detail,
  at: new Date().toISOString(),
  status: '完了'
});
